@if (_data.title) {
    <h3 class="title">{{ _data.title }}</h3>
}
<app-buttons-row vertical>
    @for (choice of _data.choices; track choice.value) {
        <app-button-action (btnClick)="emit_select(choice)">
            {{ choice.label }}
        </app-button-action>
    }
</app-buttons-row>
